import {resource} from '@albert-io/json-api-framework/request/builder';

const getClassroomQuery = (classId) =>
  resource('classroom_v1')
    .mandarkEndpoint(['classrooms_v1', classId])
    .include('school_v5.email_domains_v1,students_v2,teachers_v1')
    .fields({student_v2: 'email'})
    .withMeta('classroom_v1')
    .customQuery({
      meta: {
        context: {
          school: {
            school_license_seats_remaining: true
          }
        }
      }
    });

const getInvitationsQuery = (classId) =>
  resource('classroom_invitations_v1')
    .mandarkEndpoint(['classroom_invitations_v1'])
    .filter({classroom_v1: classId})
    .filter({accepted_at: {null: true}});

const getStudentsQuery = (classId) =>
  resource('students_v2')
    .mandarkEndpoint(['classrooms_v1', classId, 'students_v2'])
    .withMeta('student_v2')
    .customQuery({
      meta: {
        context: {
          classroom: {id: classId}
        }
      }
    });

const getCoteachersQuery = (classId) =>
  resource('teachers_v1').mandarkEndpoint(['classrooms_v1', classId, 'teachers_v1']);

export {getClassroomQuery, getInvitationsQuery, getStudentsQuery, getCoteachersQuery};
